<div class="defer-placeholder">
    <dx-load-indicator id="small-indicator" height="25" width="25"></dx-load-indicator>
    <span style="margin-left: 10px; vertical-align: top;">{{loading_message()}}</span>
</div>
